import { G, Path, Svg, View } from '@react-pdf/renderer';

export const PdfHeaderLogo: React.FC<{}> = () => {
  const st0 = {
    fill: '#ED1C24',
  };
  const st1 = {
    fill: '#FFFFFF',
  };
  const st2 = {
    fill: '#ED1C24',
  };
  const st3 = { fill: '#231F20' };

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
      <Svg width="160px" height="46px" viewBox="0 0 160 46">
        <G>
          <G>
            <G>
              <G>
                <Path
                  style={st0}
                  d="M15,8.2C15,8.2,15,8.2,15,8.2c0.2-0.3,0.1-0.6,0-0.7c-0.1-0.1-2.2-1.3-2.2-1.3c-0.2-0.1-0.3-0.3-0.3-0.5
					c0-0.3,0.2-0.5,0.6-0.7c1.3-0.4,6-0.6,7.6-0.6c0.6,0,1.5,0,2.4,0l0,0c-2.3-2-5.4-3.2-8.7-3.2C7,1.3,1,7.3,1,14.7
					c0,3.3,1.2,6.2,3.1,8.6l0,0c1.7-2.4,5.9-8.4,6.8-9.6c1.1-1.4,3.4-4.5,3.9-5.1l0,0L15,8.2z"
                />
                <Path
                  style={st0}
                  d="M6.2,25.3c2.3,1.7,5.1,2.8,8.2,2.8c7.4,0,13.4-6,13.4-13.4c0-2.2-0.6-4.4-1.5-6.2l0,0c0.5-0.4,1-1.1,0.6-2
					c-0.1-0.3-0.6-0.9-0.8-1l0,0.1c0.3,1-0.3,1.6-0.8,2c-0.3,0.2-3.7,3.4-7.7,6.9c-3.5,3.1-7.5,6.2-9.8,7.9
					c-3.2,2.4-3.8,2.8-3.8,2.8c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.5-0.2l0,0c0,0,0,0.1,0,0.1c0.3,0.6,0.9,1.2,1.2,1.2
					c0.1,0,0.2,0,0.3-0.1C5,26.2,5.2,26.1,6.2,25.3L6.2,25.3z"
                />
              </G>
              <Path
                style={st1}
                d="M15,8.2c0.2-0.3,0.1-0.5,0-0.6c-0.1-0.1-2.2-1.3-2.2-1.3c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.3,0.2-0.5,0.6-0.7
				c1.3-0.4,6-0.6,7.6-0.6c0.8,0,2.3,0,3.2,0.1c1.1,0.1,1.9,0.3,2.1,0.8c0.4,1-0.3,1.7-0.7,2.1c-0.3,0.2-3.7,3.4-7.7,6.9
				c-3.5,3.1-7.5,6.2-9.8,7.9c-3.2,2.4-3.8,2.8-3.8,2.8c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.6-0.3-0.6-0.6c0-0.1,0-0.2,0.1-0.3
				c0,0,6.3-9.1,7.5-10.7c1.2-1.5,3.9-5.1,3.9-5.1S14.8,8.4,15,8.2z"
              />
            </G>
          </G>
          <G>
            <Path style={st2} d="M32.8,42.4v-9.1h1.3v8.3H37v0.8H32.8z" />
            <Path
              style={st2}
              d="M38.3,39.3c0.1,1.6,0.9,2.4,2.3,2.4c0.9,0,1.5-0.2,1.9-0.4l0.3,0.8c-0.5,0.3-1.3,0.5-2.3,0.5
			c-2,0-3.3-1.2-3.3-3.7c0-2.4,1.3-3.7,3-3.7c1.8,0,2.9,1.1,2.9,3.5L38.3,39.3z M40.1,35.9c-1.1,0-1.9,0.8-1.9,2.8l3.6-0.5
			C41.8,36.5,41.2,35.9,40.1,35.9z"
            />
            <Path
              style={st2}
              d="M46.1,42.5c-2,0-2.9-0.8-2.9-2.1c0-1.9,1.9-2.5,4.2-2.7v-0.4c0-1.1-0.7-1.4-1.7-1.4c-0.7,0-1.4,0.3-1.8,0.5
			l-0.3-0.7c0.4-0.2,1.3-0.5,2.3-0.5c1.4,0,2.6,0.6,2.6,2.3V42C48,42.3,47.1,42.5,46.1,42.5z M47.4,38.3c-1.9,0.2-3,0.6-3,2.1
			c0,1,0.7,1.5,1.8,1.5c0.5,0,0.9-0.1,1.2-0.2V38.3z"
            />
            <Path
              style={st2}
              d="M51.1,42.5c-0.8,0-1.5-0.2-1.9-0.5l0.3-0.8c0.3,0.2,0.8,0.4,1.5,0.4c0.8,0,1.4-0.5,1.4-1.2
			c0-0.7-0.4-1.1-1.2-1.4c-1.5-0.5-1.8-1.3-1.8-2c0-1.1,0.9-2,2.2-2c0.8,0,1.4,0.2,1.8,0.5l-0.3,0.7c-0.2-0.2-0.7-0.4-1.3-0.4
			c-0.8,0-1.3,0.5-1.3,1.1c0,0.7,0.5,1,1.3,1.3c1.5,0.5,1.8,1.3,1.8,2.1C53.6,41.5,52.6,42.5,51.1,42.5z"
            />
            <Path
              style={st2}
              d="M55.1,33.9c-0.4,0-0.7-0.3-0.7-0.6c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7
			C55.8,33.6,55.5,33.9,55.1,33.9z M54.4,42.4v-7.2h1.2v7.2H54.4z"
            />
            <Path
              style={st2}
              d="M61,42.4v-5.1c0-0.7-0.3-1.4-1.6-1.4c-0.7,0-1,0.1-1.4,0.3v6.3h-1.2v-6.8c0.7-0.3,1.5-0.5,2.7-0.5
			c2.1,0,2.7,1.1,2.7,2.1v5.2H61z"
            />
            <Path
              style={st2}
              d="M65.8,45.4c-1,0-1.8-0.2-2.3-0.5l0.4-0.8c0.4,0.2,1.1,0.4,1.7,0.4c1.4,0,1.9-0.8,1.9-1.9v-0.5
			c-0.3,0.2-0.9,0.3-1.5,0.3c-1.8,0-3-1.4-3-3.5c0-2.3,1.2-3.8,3.4-3.8c1,0,1.8,0.2,2.2,0.5v6.9C68.7,44.3,67.6,45.4,65.8,45.4z
			 M67.5,36c-0.3-0.1-0.6-0.2-1.1-0.2c-1.5,0-2.2,1.2-2.2,3.1c0,1.8,0.6,2.9,2.1,2.9c0.5,0,0.9-0.1,1.2-0.3V36z"
            />
          </G>
          <Path
            style={st3}
            d="M47.9,3.9v16.9c0,3.7-3.3,6.6-7.6,6.6c-4.3,0-7.6-2.8-7.6-6.6V7.8c0-2.2,1.8-4,3.9-4H37v16.9
		c0,2,1.8,3.2,3.5,3.2c1.7,0,3.4-1.1,3.4-3.2V7.6c0-2.1,1.7-3.8,3.8-3.8H47.9z"
          />
          <Path
            style={st3}
            d="M56.2,9.8c5.8,0,6.7,3.2,6.7,5.2v12.1h-0.2c-2.1,0-3.9-1.8-3.9-3.9v-8.1c0-1.1-0.5-2.5-2.7-2.5
		c-1,0-1.7,0.1-2.3,0.4c0,0.3,0,14.1,0,14.1h-4.1v-16C51.3,10.3,54.2,9.8,56.2,9.8z"
          />
          <Path
            style={st3}
            d="M66.7,3.9C68,3.9,69,4.8,69,5.9c0,1.1-1,2-2.2,2c-1.2,0-2.2-0.9-2.2-2C64.5,4.8,65.5,3.9,66.7,3.9z M68.8,9.8
		v13.4c0,2.1-1.7,3.9-3.9,3.9h-0.2V9.8H68.8z"
          />
          <Path
            style={st3}
            d="M80.5,3.5c1.9,0,3.8,0.4,5.3,1.4v4.1c-0.9-1.2-2.2-2-4.4-2c-4.2,0-6.8,4.1-6.8,8.4c0,4,2.7,8.4,6.8,8.4
		c1.8,0,3.4-0.5,4.4-1.8v4c-1.2,0.9-3.1,1.4-5.3,1.4c-6.6,0-10.2-6.1-10.2-12C70.3,9.5,73.8,3.5,80.5,3.5z"
          />
          <Path
            style={st3}
            d="M93,9.8c0.7,0,1.5,0.1,2.3,0.2v3.3c-1.4-1-3.3-0.7-4.1-0.2v10.1c0,2.1-1.8,3.9-3.9,3.9h-0.2V11.1
		C88.7,10.4,90.4,9.8,93,9.8z"
          />
          <Path
            style={st3}
            d="M109.6,18.6L99.4,20c0.3,2.8,1.8,4.3,4.3,4.3c2.9,0,4.3-0.9,5.4-1.7v3.4c-1,0.6-3,1.2-5.8,1.2
		c-5,0-8-3.4-8-8.8c0-5.3,2.8-8.7,7.3-8.7c4.5,0,7,3,7,8.2V18.6z M106.1,16.3c-0.1-3.4-2.2-3.8-3.4-3.8h-0.2
		c-2.3,0.1-3.4,1.7-3.4,4.7L106.1,16.3z"
          />
          <Path
            style={st3}
            d="M124.4,3.9v23c-1,0.2-4.2,0.5-5.6,0.5h-0.3c-5-0.1-7.8-3-7.8-8.2c0-5.3,2.9-8.6,7.3-8.6c0.9,0,1.6,0.1,2.2,0.2
		v-3c0-2.2,1.7-3.9,3.9-3.9H124.4z M120.4,13.1c-0.4-0.1-0.9-0.2-1.4-0.2c-3.4,0-4.1,3.3-4.1,6c0,3.8,1.3,5.7,3.8,5.7
		c0.4,0,1.4-0.1,1.7-0.2V13.1z"
          />
          <Path
            style={st3}
            d="M128.4,3.9c1.2,0,2.2,0.9,2.2,2.1c0,1.1-1,2-2.2,2c-1.2,0-2.2-0.9-2.2-2C126.1,4.8,127.1,3.9,128.4,3.9z
		 M130.4,9.8v13.4c0,2.1-1.7,3.9-3.9,3.9h-0.2V9.8H130.4z"
          />
          <Path
            style={st3}
            d="M137.6,3.9v6h2.6v3.3h-2.6v9.1c0,1.1,0.4,1.4,1.6,1.4c0.3,0,0.8-0.1,1.1-0.2v3.4c-0.2,0.1-1,0.4-2.1,0.4
		c-3,0-4.7-1.5-4.7-4.2v-10h-1.8V9.8h1.8V7.7c0-2.1,1.7-3.9,3.8-3.9H137.6z"
          />
        </G>
      </Svg>
    </View>
  );
};
